import React, { FC } from 'react';
import { Modal as AntdModal } from 'antd';
import { ModalProps } from 'antd/lib/modal';

export const Modal: FC<ModalProps> = (props) => {
  return <AntdModal {...props} />;
};
export default Modal;
